import { useEffect, useState, useContext, useCallback, useRef } from "react";
import { getTimeZone } from "api/payments";
import { getCardType } from "api/graphQL_payments";
import { ClientContext } from "ClientProvider";
import SettlementTable from "./components/SettlementTable";
import ScheduleSettlementTable from "./components/ScheduleSettlementTable";
import { getOrganizationDetails } from "api/graphQL_dashboard";
import { getAllsettlement , getSchedulesettlement} from "api/settlement";
import ApmPayments from "views/admin/settlement/components/apmpayments";

export type SettlementRowObj = {
  id: string;
  name: string;
  logo: string;
  payments: boolean;
  authorization: boolean;
  subscription: boolean;
  payout: boolean;
  refund: boolean;
  apm: boolean;
  is_active: boolean;
  direct_debit?: boolean;
  payin?: boolean;
  token?: boolean;
  organization: any;
  client: any;
  created_at: any;
  total_payout: any;
  settlement_status: any;
  payout_status: any;
};

export type ScheduleSettlementRowObj = {
  id: string;
  organization_name: any;
  clients: any;
  settlement_details: any;
  schedule_type: any;
  execution_time: any;
  execution_day: any;
  status: any;
  created_at: any;
  updated_at: any;
  total_settlement_generated: any;
};

const Settlement = () => {
  const [paymentData, setPaymentData] = useState<SettlementRowObj[]>([]);
  const [scheduleData, setScheduleData] = useState<any[]>([]);

  const [isListLoading, setIsListLoading] = useState<boolean>();
  const [isScheduleLoading, setIsScheduleLoading] = useState<boolean>();
  
  const [page, setPage] = useState<number>(1);
  const [schedulePage, setSchedulePage] = useState<number>(1);

  const [totalpage, setTotalPage] = useState<number>(0);
  const [totalSchedulePage, setTotalSchedulePage] = useState<number>(0);

  const [totalItems, setTotalItems] = useState<number>(0);
  const [totalScheduleItems, setTotalScheduleItems] = useState<number>(0);

  const [pageSize, setPageSize] = useState<number>(50);
  const [pageScheduleSize, setPageScheduleSize] = useState<number>(50);

  const [currentPage, setCurrentPage] = useState<number>(1);
  const [currentSchedulePage, setCurrentSchedulePage] = useState<number>(1);

  const { singleRoleData } = useContext(ClientContext);
  const [searchTexts, setSearchTexts] = useState<string>("");
  const [timeZone, setTimeZone] = useState<any>();
  const [allCardType, setCardType] = useState<any>();
  const [allOrgDetails, setAllOrgDetails] = useState<any>();
  const isResetting = useRef(false);
  const [clearClicked, setClearClick] = useState(0);  
  const { activeSettlementTab, setActiveSettlementTab } = useContext(ClientContext);
  const [filter, setFilter] = useState({
    clients: [] , organizations: [] , payment_status: [] , settlement_status : [],dates: null
  });

  const fetchSchedulesettlement = useCallback(() => {
    setIsScheduleLoading(true);

    getSchedulesettlement(schedulePage, pageScheduleSize)
      .then((data) => {
        setScheduleData(data[0] ?? []);
        setTotalSchedulePage(data?.[1]?.total_pages);
        setTotalScheduleItems(data?.[1]?.total_items);
        setCurrentSchedulePage(data?.[1]?.current_page);
      })
      .finally(() => {
        setIsScheduleLoading(false);
      });
  }, [schedulePage, pageScheduleSize]);

  const fetchAllsettlement = useCallback(() => {
    setIsListLoading(true);
    getAllsettlement(page, pageSize, searchTexts,filter)
      .then((data) => {
        setPaymentData(data[0] ?? []);
        setTotalPage(data?.[1]?.total_pages);
        setTotalItems(data?.[1]?.total_items);
        setCurrentPage(data?.[1]?.current_page);
      })
      .catch((err) => {})
      .finally(() => {
        setIsListLoading(false);
      });
  }, [page, pageSize, searchTexts]);

  const fetchTimeZone = () => {
    getTimeZone()
      .then((data) => { setTimeZone(data ?? []); })
      .catch(() => {})
      .finally(() => {});
  };

  const fetchCardType = () => {
    getCardType()
      .then((data) => { setCardType(data); })
      .catch(() => {})
      .finally(() => {});
  };

  const serchboxValueChange = async (searchTerm: string) => {
    const search_txt = searchTerm || "";
    if (search_txt !== searchTexts && searchTexts !== "") {
      await setSearchTexts(search_txt);
      setPage(1);
      setCurrentPage(1);
    } else {
      await setSearchTexts(search_txt);
    }
  };

  useEffect(() => {
    if (activeSettlementTab == 'all-settlements') {
      fetchAllsettlement();
    }
  }, [searchTexts, page, pageSize, fetchAllsettlement,clearClicked,activeSettlementTab]);

  useEffect(() => {
    if (activeSettlementTab === "schedule-settlements") {
      fetchSchedulesettlement();
    }
  }, [fetchSchedulesettlement, activeSettlementTab]);

  useEffect(() => {
    setPageSize(50);
  }, [searchTexts]);

  
  useEffect(() => { onClearClick(); }, []);

  const onClearClick = () => setClearClick((prev) => prev + 1);

  const fecthOrgData = () => {
    getOrganizationDetails()
      .then((data) => {
        setAllOrgDetails(
          data?.map((d: any) => ({
            ...d?.organization,
            label: d?.organization?.name,
            value: d?.organization?.id,
          }))
        );
      })
      .catch(() => {});
  };

  useEffect(() => {
    fetchTimeZone();
    fetchCardType();
    fecthOrgData();
  }, []);

  const filterData = () => {
    setIsListLoading(true);
    getAllsettlement(page, pageSize, searchTexts,filter)
      .then((data) => {
        setPaymentData(data[0] ?? []);
        setTotalPage(data?.[1]?.total_pages);
        setTotalItems(data?.[1]?.total_items);
        setCurrentPage(data?.[1]?.current_page);
      })
      .catch((err) => {})
      .finally(() => {
        setIsListLoading(false);
      });
  };

  return (
    <div className="smt-root">
      {/* Page header */}
      <div className="smt-page-header">
        <div className="smt-page-title-block">
          <div className="smt-page-icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="1" y="4" width="22" height="16" rx="2" />
              <line x1="1" y1="10" x2="23" y2="10" />
            </svg>
          </div>
          <div> 
            <h1 className="smt-page-heading">Settlements</h1>
            <p className="smt-page-sub">Manage settlement reports and payout approvals</p>
          </div>
        </div>        
      </div>

      <div className="po-tab-wrap">
        <div className="po-tab-track">
          <div
            className="po-tab-slider"
            style={{
              transform: activeSettlementTab === "all-settlements" ? "translateX(0%)" : "translateX(100%)",
            }}
          />
          <button
            onClick={() => { setActiveSettlementTab("all-settlements"); setFilter({clients: [] , organizations: [] , payment_status: [] , settlement_status : [],dates: null}); }}
            className={`po-tab-btn${activeSettlementTab === "all-settlements" ? " po-tab-btn--active" : ""}`}
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M20 12V22H4V12"/>
              <path d="M22 7H2v5h20V7z"/>
              <path d="M12 22V7"/>
            </svg>
            All Settlements 
          </button>
          <button
            onClick={() => setActiveSettlementTab("schedule-settlements")}
            className={`po-tab-btn${activeSettlementTab === "schedule-settlements" ? " po-tab-btn--active" : ""}`}
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="2" y="7" width="20" height="14" rx="2"/>
              <path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"/>
              <line x1="12" y1="12" x2="12" y2="16"/>
              <line x1="10" y1="14" x2="14" y2="14"/>
            </svg>
            Scheduled Settlements
          </button>
        </div>
      </div>

      <div className="po-content-card">
        {activeSettlementTab === "all-settlements" && (
          <SettlementTable
            pageSize={pageSize}
            setPageSize={setPageSize}
            tableData={paymentData}
            fetchAllsettlement={fetchAllsettlement}
            isLoading={isListLoading}
            page={page}
            setPage={setPage}
            totalpage={totalpage}
            totalItems={totalItems}
            currentPage={currentPage}
            roleData={singleRoleData}
            timeZone={timeZone}
            allCardType={allCardType}
            onValueChange={serchboxValueChange}
            allOrgDetails={allOrgDetails}
            filter={filter}
            setFilter={setFilter}
            setClearClick={onClearClick}
            filterData={filterData}
          />
        )}
        {activeSettlementTab === "schedule-settlements"  && (
          <ScheduleSettlementTable
            allOrgDetails={allOrgDetails}
            page={schedulePage}
            setPage={setSchedulePage}
            totalpage={totalSchedulePage}
            totalItems={totalScheduleItems}
            currentPage={currentSchedulePage}
            pageSize={pageScheduleSize}
            setPageSize={setPageScheduleSize}
            roleData={singleRoleData}
            fetchAllsettlement={fetchSchedulesettlement}
            isLoading={isScheduleLoading}
            tableData={scheduleData}
          />
        )}
      </div>
      
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');

        .smt-root {
          font-family: 'Plus Jakarta Sans', sans-serif;
          min-height: 100vh;
          display: flex;
          flex-direction: column;
          gap: 20px;
        }
        .smt-page-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;
          gap: 16px;
        }
        .smt-page-title-block { display: flex; align-items: center; gap: 14px; }
        .smt-page-icon {
          width: 44px; height: 44px; border-radius: 12px;
          background: linear-gradient(135deg, #eff6ff, #dbeafe);
          border: 1.5px solid #bfdbfe;
          display: flex; align-items: center; justify-content: center;
          color: #2563eb; flex-shrink: 0;
        }
        .smt-page-heading {
          font-size: 20px; font-weight: 800; color: #0f172a;
          letter-spacing: -0.4px; margin-bottom: 2px; line-height: 22px;
        }
        .smt-page-sub { font-size: 13px; color: #94a3b8; font-weight: 500; }
        .smt-page-actions { display: flex; gap: 10px; align-items: center; flex-wrap: wrap; }

        @media (max-width: 600px) {
          .smt-root { padding: 14px; gap: 14px; }
          .smt-page-header { flex-direction: column; align-items: flex-start; }
        }

        .smt-tab-wrap { display:flex; }
        .smt-tab-track {
          position:relative; display:flex;
          background:#f1f5f9; border:1.5px solid #e2e8f0;
          border-radius:12px; padding:4px; gap:0;
        }
        .smt-tab-slider {
          position:absolute; top:4px; bottom:4px;
          width:calc(50% - 4px);
          background:#fff; border-radius:9px;
          box-shadow:0 2px 8px rgba(15,23,42,.1);
          transition:transform .25s cubic-bezier(0.16,1,0.3,1);
          pointer-events:none;
        }
        .smt-tab-btn {
          position:relative;
          display:inline-flex; align-items:center; gap:7px;
          font-family:'Plus Jakarta Sans',sans-serif;
          font-size:13px; font-weight:600; color:#64748b;
          padding:10px 24px; border:none; background:none;
          border-radius:9px; cursor:pointer; transition:color .2s;
          white-space:nowrap;
        }
        .smt-tab-btn--active { color:#2563eb; font-weight:700; }

        .smt-batch-add-grid { display:grid; grid-template-columns:repeat(auto-fill,minmax(240px,1fr)); gap:16px; }

        /* ── Tab toggle ── */
        .po-tab-wrap { display: flex; }
        .po-tab-track {
          position: relative;
          display: inline-flex;   /* was flex + fit-content */
          background: #f1f5f9;
          border: 1.5px solid #e2e8f0;
          border-radius: 12px;
          padding: 4px;
          gap: 0;
        }

        .po-tab-slider {
          position: absolute;
          top: 4px; bottom: 4px;
          left: 4px;
          width: calc(50% - 4px);
          background: #fff;
          border-radius: 9px;
          box-shadow: 0 2px 8px rgba(15,23,42,.1);
          transition: transform .25s cubic-bezier(0.16,1,0.3,1);
          pointer-events: none;
        }

        .po-tab-btn {
          position: relative;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 7px;
          font-family: 'Plus Jakarta Sans', sans-serif;
          font-size: 13px;
          font-weight: 600;
          color: #64748b;
          padding: 10px 20px;
          border: none;
          background: none;
          border-radius: 9px;
          cursor: pointer;
          transition: color .2s;
          white-space: nowrap;
          flex: 0 0 auto;
          min-width: 190px;   /* forces both buttons to match exactly */
        }

        .po-tab-btn--active { color: #2563eb; font-weight: 700; }
        .po-tab-btn:hover:not(.po-tab-btn--active) { color: #334155; }

        @media (max-width: 600px) {
          .po-tab-btn { padding: 10px 14px; font-size: 12.5px; min-width: 160px; }
          .po-root { padding: 16px 0; }
        }

        /* ── Content card ── */
        .po-content-card {
          background: #fff;
          border: 1px solid #e2e8f0;
          border-radius: 18px;
          box-shadow: 0 2px 8px rgba(15,23,42,0.06);
          overflow: hidden;
        }

      `}</style>
    </div>
  );
};

export default Settlement;